export enum TransformStyleEnum {
  none = 'none',
  scale = 'scale',
  translateY = 'translateY',
  translateX = 'translateX',
}
